module.exports = __webpack_public_path__ + "img/yellow.3e8910dc.png";